/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// NOTE: This is a stopgap for personalization using the current GCI implementation and will eventually be deprecated.

import React, { useState, useEffect, useContext } from 'react';
import { compose } from 'recompose';
import {
    string, shape, object, func, bool,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import mbpLogger from 'mbp-logger';

import CloseIcon from '@material-ui/icons/Close';
import {
    Dialog, DialogContent, IconButton,
} from '@material-ui/core';

import CelebrationsGreetingCard from '../../../../../pages/CGC/CelebrationsGreetingCard';
import { CrossMerch } from '../../../CrossMerchContainer/CrossMerchContainer';
import useCgcMessage from '../useCgcMessage';

import { setGCIData, clearGCIData, fetchGCIKey } from '../../../../../../state/ducks/App/App-Actions';
import { getGCIData, getCGCCardError, getGCIPersonalizationKey } from '../../../../../../state/ducks/App/App-Selectors';
import { setCGCCardError, getCGCCustomCardData } from '../../../../../../state/ducks/CGC/CGC-Actions';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getLoaderStatus } from '../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import GCIPersonalizationV2 from './GCIPersonalizationV2';
import GCIPersonalizationV1 from './GCIPersonalizationV1';
import getBrandDomainById from '../../../../../helpers/getBrandDomain';

const styles = (theme) => ({
    iframe: {
        height: '600px',
        width: '920px',
        borderStyle: 'none',
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    typography: {
        fontWeight: 'bold',
        marginBottom: '5px',
        [theme.breakpoints.down(900)]: {
            margin: 0,
        },
    },
    gciContent: {
        maxWidth: '100vw',
        display: 'flex',
        justifyContent: 'center',
    },
    maxWidth: {
        '& > div > div': {
            maxWidth: '70%',
            minWidth: '1000px',
        },
    },
    error: {
        color: theme.palette.cms?.errorZipVerifyPDP || '#A1001A',
        paddingBottom: '10px',
    },
});

const GCIPersonalization = ({
    actionGetGCIKey,
    actionSetSelectedGCIData,
    actionRemoveGCIData,
    brand,
    classes,
    selectedSku,
    gciKey,
    getUpdatedPersonalizedProdData,
    cgcCardError,
    setCGCError,
    gciData,
    fetchCustomCardData,
    loader,
    isPdpRedesignEnabled,
}) => {
    const { featureFlags = {} } = useContext(CrossMerch);
    const brandDomain = getBrandDomainById(selectedSku?.brandId); // get product's brand domain in case product not from current brand (so we can display appropriate calendar)
    const {  data: messageData, loading } = useCgcMessage({ productBrand: brandDomain });
    const cgcMessageData = messageData?.findContent?.content?.entries?.[0] || {};
    // TODO this can be simplified
    const showGCISection = () => {
        if (
            selectedSku?.personalization?.personalizationDefDesign
            && selectedSku?.personalization?.personalizationTemplate
            && (featureFlags['is-gci-enabled'] || featureFlags['is-celebration-card-enabled-pdp'])
        ) {
            const { personalizationDefDesign, personalizationTemplate } = selectedSku?.personalization;
            if (personalizationDefDesign && personalizationTemplate) {
                return true;
            }
        }
        return false;
    };
    const [showModal, setModalState] = useState(false);

    const params = {
        productCode: selectedSku?.id,
        brandCode: selectedSku?.brandId || brand?.id,
        brand: brand?.domain,
    };

    const personalizationDefDesign = selectedSku?.personalization?.personalizationDefDesign || '';
    const personalizationTemplate = selectedSku?.personalization?.personalizationTemplate || '';

    const setCGCLabelsData = (data) => {
        actionSetSelectedGCIData({ ...data, productId: selectedSku?.id });
        const personalization = {
            personalizationType: 'PRODUCT_PERSONALIZATION_GCI',
            productPersonalization: {
                ...data,
                productCode: personalizationDefDesign,
                brandCode: selectedSku.brandId || brand?.id,
            },
        };
        getUpdatedPersonalizedProdData(personalization);
    };

    useEffect(() => {
        if (!featureFlags['is-cgc-api-from-main-url']) {
            if (!gciKey) {
                actionGetGCIKey(params);
            } else if (gciKey && gciData?.key_id) {
                fetchCustomCardData(gciKey);
                setCGCLabelsData(gciData); // this will set local state of pdp
            }
        } else if (gciData?.key_id) {
            setCGCLabelsData(gciData); // this will set local state of pdp
        }
        setCGCError('');
    }, []);

    useEffect(() => {
        // getting new Key id after adding the personalization to cart
        if (!gciKey && !params?.key_id) {
            if (!featureFlags['is-cgc-api-from-main-url']) {
                actionGetGCIKey(params);
            }
            setCGCError('');
        }
    }, [gciKey, params?.key_id]);

    const removeGCIData = () => {
        actionRemoveGCIData();
        getUpdatedPersonalizedProdData({});
    };

    if (cgcCardError && gciData && Object.keys(gciData).length > 0) {
        removeGCIData();
    }
    // Clean the GCI data and get a new key if it is empty
    if (!featureFlags['is-cgc-api-from-main-url'] && gciKey === '' && gciData && Object.keys(gciData).length > 0) {
        actionGetGCIKey(params);
        removeGCIData();
    }

    const baseUrl = 'https://cardapi.giftcardimpressions.com/800f/physicalcards';
    const url = `${baseUrl}/product/?key_id=${gciKey}&sku=${personalizationDefDesign}&occasion_id=all&brand_name=${brand?.id}&changecard=1&personalization_type=${personalizationTemplate}`;
    const dataListener = () => {
        if (typeof window !== 'undefined') {
            const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
            const eventer = window[eventMethod];
            const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
            eventer(messageEvent, (event) => {
                if (typeof event.data !== 'undefined') {
                    let data = event.data;
                    try {
                        if (typeof event.data === 'string') {
                            data = JSON.parse(event.data);
                            if (data.action === 'personalizationComplete') {
                                const { sku, text, ...personalizationData } = data;

                                const personalization = {
                                    personalizationType: 'PRODUCT_PERSONALIZATION_GCI',
                                    productPersonalization: {
                                        ...personalizationData,
                                        productCode: sku,
                                        brandCode: selectedSku.brandId || brand?.id,
                                        // this regex removes all new line characters from string
                                        text: text.replace(/[\n\r]/g, ''),
                                    },
                                };
                                actionSetSelectedGCIData({ ...data, productId: selectedSku?.id });
                                setModalState(false);
                                getUpdatedPersonalizedProdData(personalization);
                            }
                        }
                    } catch (e) {
                        mbpLogger.logError({
                            function: 'GCI',
                            appName: process.env.npm_package_name,
                            module: 'mbp-pwa-ui',
                            jsError: e,
                            message: 'GCI frame failed',
                        });
                    }
                }
            });
        }
    };

    const editCGCLabelData = () => {
        if (gciKey && gciData?.key_id) {
            fetchCustomCardData(gciKey);
        }
        setModalState(true);
    };

    const isCgcEnabled = featureFlags['is-celebration-card-enabled-pdp'];
    const placementText = !gciData?.coverImage ?  'Your Photo' : '';

    if (!showGCISection()) {
        return null;
    }
    if (!selectedSku?.personalization) { return null; }

    return (
        <>
            {featureFlags['is-pdp-photo-label-enabled']
                ? (
                    <GCIPersonalizationV2
                        featureFlags={featureFlags}
                        gciKey={gciKey}
                        gciData={gciData}
                        loader={loader}
                        setModalState={setModalState}
                        editCGCLabelData={editCGCLabelData}
                        removeGCIData={removeGCIData}
                        placementText={placementText}
                        loading={loading}
                        cgcMessageData={cgcMessageData}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                    />
                )
                : (
                    <GCIPersonalizationV1
                        featureFlags={featureFlags}
                        gciKey={gciKey}
                        gciData={gciData}
                        loader={loader}
                        setModalState={setModalState}
                        editCGCLabelData={editCGCLabelData}
                        removeGCIData={removeGCIData}
                        placementText={placementText}
                        loading={loading}
                        cgcMessageData={cgcMessageData}
                        messageData={messageData}
                    />
                )}

            {
                (isCgcEnabled) ?                     (
                    <CelebrationsGreetingCard
                        openModal={showModal}
                        closeModal={() => setModalState(false)}
                        isCelebrationsCustomsCard
                        personalizationCustomsType={personalizationDefDesign}
                        cartItemId={selectedSku?.id}
                        updateCGCCustomsData={setCGCLabelsData}
                        customCardData={gciData}
                        productSku={selectedSku?.id}
                        setCGCLabelData={getUpdatedPersonalizedProdData}
                    />
                ) : (
                    <Dialog
                        onClose={() => setModalState(false)}
                        open={showModal}
                        fullWidth
                        className={classes.maxWidth}
                        data-testid="personalization-modal"
                    >
                        <IconButton aria-label="Close" className={classes.closeButton} onClick={() => setModalState(false)}>
                            <CloseIcon />
                        </IconButton>
                        <DialogContent className={classes.gciContent}>
                            <iframe
                                onLoad={dataListener()}
                                className={classes.iframe}
                                title="GCIIframe"
                                id="GCIFrame"
                                src={url}
                            />
                        </DialogContent>
                    </Dialog>
                )
            }
            {cgcCardError && <div className={classes.error}>{cgcCardError}</div>}
        </>
    );
};

GCIPersonalization.propTypes = {
    classes: object.isRequired,
    selectedSku: object.isRequired,
    brand: shape({
        id: string.isRequired,
    }).isRequired,
    actionSetSelectedGCIData: func.isRequired,
    actionRemoveGCIData: func.isRequired,
    actionGetGCIKey: func.isRequired,
    gciKey: string,
    getUpdatedPersonalizedProdData: func.isRequired,
    cgcCardError: string,
    setCGCError: func.isRequired,
    gciData: shape({
        key_id: string,
        text: string,
        thumbnail: string,
    }),
    fetchCustomCardData: func.isRequired,
    loader: bool,
    isPdpRedesignEnabled: bool,
};

GCIPersonalization.defaultProps = {
    gciKey: '',
    cgcCardError: '',
    gciData: {
        key_id: '',
        text: '',
        thumbnail: '',
    },
    loader: false,
    isPdpRedesignEnabled: false,
};

const mapStateToProps = (state) => ({
    gciKey: getGCIPersonalizationKey(state),
    cgcCardError: getCGCCardError(state),
    gciData: getGCIData(state),
    brand: getBrand(state),
    loader: getLoaderStatus(state),
});

const mapDispatchToProps = (dispatch) => ({
    actionSetSelectedGCIData: bindActionCreators(setGCIData, dispatch),
    actionRemoveGCIData: bindActionCreators(clearGCIData, dispatch),
    actionGetGCIKey: bindActionCreators(fetchGCIKey, dispatch),
    setCGCError: bindActionCreators(setCGCCardError, dispatch),
    fetchCustomCardData: bindActionCreators(getCGCCustomCardData, dispatch),
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(styles),
)(GCIPersonalization);
